import { Component, Input, OnInit } from "@angular/core";
import { SmmPageService } from "../../_services/smm-page.service";
import { SmmUserService } from "../../_services/smm-user.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { FieldsService } from "app/_services/fields.service";
const moment = require("moment");
@Component({
  selector: "app-project-detail",
  templateUrl: "./project-detail.component.html",
  styleUrls: ["./project-detail.component.scss"],
})
export class ProjectDetailComponent implements OnInit {
  public VIEW_KEY = 1;
  public VIEW_USER = 2;
  public VIEW_PAGE = 3;
  public TYPE_KEYS = "keywords";
  public TYPE_PAGES = "pages";
  public TYPE_USERS = "users";

  @Input() project;
  @Input() view;

  field = "";
  isCurrentUrl = "";
  keywordStr = "";
  positive_keywords = "";
  negative_keywords = "";
  article_keywords = "";
  neutral_keywords = "";
  notKeywords = "";
  negative_default_keywords = "";
  emailStr = "";
  pageStr = "";
  userStr = "";
  idTelegram = "";
  hasAlert = false;
  account = localStorage.getItem('currentSmmAccount') ? JSON.parse(localStorage.getItem('currentSmmAccount')) : {};
  fieldsDropdownList = [];
  listTimes = [
    { name: "Ngay lập tức", value: 0 },
    { name: "10 phút", value: 0.16 },
    { name: "20 phút", value: 0.33 },
    { name: "30 phút", value: 0.5 },
    { name: "1 giờ", value: 1 },
    { name: "2 giờ", value: 2 },
    { name: "3 giờ", value: 3 },
    { name: "6 giờ", value: 6 },
    { name: "12 giờ", value: 12 },
    { name: "24 giờ", value: 24 },
  ];

  constructor(
    private smmUserService: SmmUserService,
    private smmPageService: SmmPageService,
    private toastrService: ToastrService,
    private fieldsService: FieldsService,
    route: Router
  ) {
    this.view = this.VIEW_KEY;
    this.isCurrentUrl = route.url;
    // console.log("account: ", account);
    
  }

  ngOnInit() {
    this.getFields();
    if (!this.project.article_keywords) {
      this.project["article_keywords"] = [];
    }
    if (this.project.field) {
      this.field = this.project.field._id;
    }
  }

  getFields() {
    this.fieldsDropdownList = [];
    this.fieldsService.getAll().subscribe(response => {
      if (response.success) {
        const fields = response.data.fields;
        for (var i = 0; i < fields.length; i++) {
          let obj = {
            _id: fields[i]._id,
            name: fields[i].name,
            smallFields: fields[i].small_fields,
            keymap: fields[i].keymap
          };
          this.fieldsDropdownList.push(obj);
        }
      }
    });
  }

  findUser() {
    if (this.userStr !== "") {
      this.smmUserService.searchUserByIdOrLink(0, 10, this.userStr).subscribe(
        (res) => {
          const data = res.data;
          if (data.hits.hits.length > 0) {
            const id = data.hits.hits[0]["_id"];
            this.project.users.push({
              name: data.hits.hits[0]["_source"].name,
              id: id,
            });
            this.userStr = "";
          } else {
            this.toastrService.info(
              "Tài khoản Facebook không hợp lệ",
              "Thông báo"
            );
          }
        },
        (err) => {}
      );
    } else {
      this.toastrService.warning("Vui lòng nhập đường dẫn", "Cảnh báo");
    }
  }

  findPage() {
    if (this.pageStr !== "") {
      console.log("this.pageStr : ", this.pageStr);
      // this.pageStr = this.extractIdFromLink(this.pageStr);
      this.smmPageService.searchPageByIdOrLink(0, 10, this.pageStr).subscribe(
        (res) => {
          const data = res.data;
          if (data.hits.hits.length > 0) {
            const id = data.hits.hits[0]["_id"];
            this.project.pages.push({
              name: data.hits.hits[0]["_source"].name,
              id: id,
            });
            this.pageStr = "";
          } else {
            this.toastrService.info(
              "Không tìm thấy trang này trong hệ thống",
              "Thông báo"
            );
          }
        },
        (err) => {}
      );
    } else {
      this.toastrService.warning("Vui lòng nhập đường dẫn", "Cảnh báo");
    }
  }

  deleteKeyword(element, typeKeyword) {
    if (typeKeyword === "keywordStr") {
      this.project.keywords.splice(this.project.keywords.indexOf(element), 1);
    } else if (typeKeyword === "positive_keywords") {
      this.project.positive_keywords.splice(
        this.project.positive_keywords.indexOf(element),
        1
      );
    } else if (typeKeyword === "neutral_keywords") {
      this.project.neutral_keywords.splice(
        this.project.neutral_keywords.indexOf(element),
        1
      );
    } else if (typeKeyword === "negative_keywords") {
      this.project.negative_keywords.splice(
        this.project.negative_keywords.indexOf(element),
        1
      );
    } else if (typeKeyword === "article_keywords") {
      this.project.article_keywords.splice(
        this.project.article_keywords.indexOf(element),
        1
      );
    } else if (typeKeyword === "telegram") {
      this.project.idTelegrams.splice(
        this.project.idTelegrams.indexOf(element),
        1
      );
    }
  }

  deleteNotKeyword(element) {
    this.project.notKeywords.splice(
      this.project.notKeywords.indexOf(element),
      1
    );
  }

  deleteNegativeDefaultKeyword(element) {
    this.project.negative_default_keywords.splice(
      this.project.negative_default_keywords.indexOf(element),
      1
    );
  }

  deleteUser(element) {
    this.project.users.splice(this.project.users.indexOf(element), 1);
  }

  deletePage(element) {
    this.project.pages.splice(this.project.pages.indexOf(element), 1);
  }

  addKeyword(event, typeKeyword) {
    this.handlerKeyword(this.keywordStr);
    if (typeKeyword === "keywordStr") {
      if (this.keywordStr !== "") {
        if (this.keywordStr.length < 1000) {
          let listKeyWords = this.handlerKeyword(this.keywordStr);
          for (var i in listKeyWords) {
            if (this.project.keywords.indexOf(listKeyWords[i]) < 0) {
              this.project.keywords.push(listKeyWords[i]);
            } else {
              this.toastrService.warning(
                `Từ khóa ${listKeyWords[i]} đã tồn tại!`,
                "Cảnh báo"
              );
            }
          }
          this.keywordStr = "";
        } else {
          this.toastrService.warning(
            "Từ khóa không được quá 1000 ký tự!",
            "Cảnh báo"
          );
        }
      } else {
        this.toastrService.warning("Không được để trống từ khóa!", "Cảnh báo");
      }
    } else if (typeKeyword === "positive_keywords") {
      if (this.positive_keywords !== "") {
        if (this.positive_keywords.length < 1000) {
          let listKeyWords = this.handlerKeyword(this.positive_keywords);
          for (var i in listKeyWords) {
            if (this.project.positive_keywords.indexOf(listKeyWords[i]) < 0) {
              this.project.positive_keywords.push(listKeyWords[i]);
            } else {
              this.toastrService.warning(
                `Từ khóa ${listKeyWords[i]} đã tồn tại!`,
                "Cảnh báo"
              );
            }
          }
          this.positive_keywords = "";
        } else {
          this.toastrService.warning(
            "Từ khóa không được quá 1000 ký tự!",
            "Cảnh báo"
          );
        }
      } else {
        this.toastrService.warning("Không được để trống từ khóa!", "Cảnh báo");
      }
    } else if (typeKeyword === "article_keywords") {
      if (this.article_keywords !== "") {
        if (this.article_keywords.length < 1000) {
          let listKeyWords = this.handlerKeyword(this.article_keywords);
          for (var i in listKeyWords) {
            if (this.project.article_keywords.indexOf(listKeyWords[i]) < 0) {
              this.project.article_keywords.push(listKeyWords[i]);
            } else {
              this.toastrService.warning(
                `Từ khóa ${listKeyWords[i]} đã tồn tại!`,
                "Cảnh báo"
              );
            }
          }
          this.article_keywords = "";
        } else {
          this.toastrService.warning(
            "Từ khóa không được quá 1000 ký tự!",
            "Cảnh báo"
          );
        }
      } else {
        this.toastrService.warning("Không được để trống từ khóa!", "Cảnh báo");
      }
    } else if (typeKeyword === "neutral_keywords") {
      if (this.neutral_keywords !== "") {
        if (this.neutral_keywords.length < 1000) {
          let listKeyWords = this.handlerKeyword(this.neutral_keywords);
          for (var i in listKeyWords) {
            if (this.project.neutral_keywords.indexOf(listKeyWords[i]) < 0) {
              this.project.neutral_keywords.push(listKeyWords[i]);
            } else {
              this.toastrService.warning(
                `Từ khóa ${listKeyWords[i]} đã tồn tại!`,
                "Cảnh báo"
              );
            }
          }
          this.neutral_keywords = "";
        } else {
          this.toastrService.warning(
            "Từ khóa không được quá 1000 ký tự!",
            "Cảnh báo"
          );
        }
      } else {
        this.toastrService.warning("Không được để trống từ khóa!", "Cảnh báo");
      }
    } else if (typeKeyword === "negative_keywords") {
      if (this.negative_keywords !== "") {
        if (this.negative_keywords.length < 1000) {
          let listKeyWords = this.handlerKeyword(this.negative_keywords);
          for (var i in listKeyWords) {
            if (this.project.negative_keywords.indexOf(listKeyWords[i]) < 0) {
              this.project.negative_keywords.push(listKeyWords[i]);
            } else {
              this.toastrService.warning(
                `Từ khóa ${listKeyWords[i]} đã tồn tại!`,
                "Cảnh báo"
              );
            }
          }
          this.negative_keywords = "";
        } else {
          this.toastrService.warning(
            "Từ khóa không được quá 1000 ký tự!",
            "Cảnh báo"
          );
        }
      } else {
        this.toastrService.warning("Không được để trống từ khóa!", "Cảnh báo");
      }
    } else if (typeKeyword === "telegram") {
      if (this.idTelegram !== "") {
        if (this.idTelegram.length < 1000) {
          let listId = this.handlerKeyword(this.idTelegram);
          for (var i in listId) {
            if (this.project.idTelegrams.indexOf(listId[i]) < 0) {
              this.project.idTelegrams.push(listId[i]);
            } else {
              this.toastrService.warning(
                `Id nhóm telegram ${listId[i]} đã tồn tại!`,
                "Cảnh báo"
              );
            }
          }
          this.idTelegram = "";
        } else {
          this.toastrService.warning(
            "Id nhóm telegram không được quá 1000 ký tự!",
            "Cảnh báo"
          );
        }
      } else {
        this.toastrService.warning(
          "Không được để trống Id nhóm telegram!",
          "Cảnh báo"
        );
      }
    }
  }
  handlerKeyword(keyword) {
    var listKeywords = keyword.split("|");
    for (var i in listKeywords) {
      listKeywords[i] = listKeywords[i].trim();
      if (listKeywords[i] == "") {
        delete listKeywords[i];
      }
    }
    return listKeywords;
  }
  addNegativeKeywordDefault(event) {
    if (this.negative_default_keywords !== "") {
      if (this.negative_default_keywords.length < 1000) {
        let listKeyWords = this.handlerKeyword(this.negative_default_keywords);
        for (var i in listKeyWords) {
          if (
            this.project.negative_default_keywords.indexOf(listKeyWords[i]) < 0
          ) {
            this.project.negative_default_keywords.push(listKeyWords[i]);
          } else {
            this.toastrService.warning(
              `Từ khóa ${listKeyWords[i]} đã tồn tại!`,
              "Cảnh báo"
            );
          }
        }
        this.negative_default_keywords = "";
      } else {
        this.toastrService.warning(
          "Từ khóa tiêu cực mặc định không được quá 1000 ký tự!",
          "Cảnh báo"
        );
      }
    } else {
      this.toastrService.warning(
        "Không được để trống từ khóa tiêu cực mặc định!",
        "Cảnh báo"
      );
    }
  }
  addUnsubKeyword(event) {
    if (this.notKeywords !== "") {
      if (this.notKeywords.length < 1000) {
        let listKeyWords = this.handlerKeyword(this.notKeywords);
        for (var i in listKeyWords) {
          if (this.project.notKeywords.indexOf(listKeyWords[i]) < 0) {
            this.project.notKeywords.push(listKeyWords[i]);
          } else {
            this.toastrService.warning(
              `Từ khóa ${listKeyWords[i]} đã tồn tại!`,
              "Cảnh báo"
            );
          }
        }
        this.notKeywords = "";
      } else {
        this.toastrService.warning(
          "Từ khóa loại trừ không được quá 1000 ký tự!",
          "Cảnh báo"
        );
      }
    } else {
      this.toastrService.warning(
        "Không được để trống từ khóa loại trừ!",
        "Cảnh báo"
      );
    }
  }

  updateField() {
    const fieldDetail = this.fieldsDropdownList.find(field => field._id == this.field);
    this.project.field = fieldDetail;
  }

  addEmail() {
    if (this.emailStr !== "") {
      if (this.emailStr.length < 1000) {
        if (this.project.alertEmailCc.indexOf(this.emailStr) < 0) {
          this.project.alertEmailCc.push(this.emailStr);
          this.emailStr = "";
        } else {
          this.toastrService.warning("Từ khóa đã tồn tại!", "Cảnh báo");
        }
      } else {
        this.toastrService.warning(
          "Từ khóa không được quá 1000 ký tự!",
          "Cảnh báo"
        );
      }
    } else {
      this.toastrService.warning("Không được để trống từ khóa!", "Cảnh báo");
    }
  }

  deleteEmail(element) {
    this.project.alertEmailCc.splice(
      this.project.alertEmailCc.indexOf(element),
      1
    );
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/projects/project-detail/project-detail.component.ts